import { Injectable } from '@angular/core';
import { EmailDomainModel } from '../../../models/master-data/email-domain.model';
import { MasterDataUrl } from '../../../shared/urls/master-data.urls';
import { BaseService } from '../../../shared/services/base.service';

@Injectable()
export class EmailDomainService {
    constructor(public baseService: BaseService) {

    }
    getEmailDomainList(param) {
        const url = MasterDataUrl.GET_EMAIL_DOMAIN;
        return this.baseService.getData(url, param);
    }

    getEmailDomain(id) {
        const url = MasterDataUrl.GET_EMAIL_DOMAIN_BY_ID.replace('{id}', id);
        return this.baseService.getData(url);
    }

    addNewEmailDomain(param){
        const url = MasterDataUrl.ADD_EMAIL_DOMAIN;
        return this.baseService.postData(url,param);
    }

    deleteEmailDomain(id){
        const url = MasterDataUrl.REMOVE_EMAIL_DOMAIN.replace('{id}', id);
        return this.baseService.delete(url);
    }
    updateEmailDomain(param){
        const url = MasterDataUrl.UPDATE_EMAIL_DOMAIN; 
        return this.baseService.put(url, param)
    }
}




// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/master-data/email-domain/email-domain.service.ts